const buttonVariantTokens = (mainColors) => ({
    fill: {
        color: mainColors.goten,
        backgroundColor: mainColors.piccolo,
    },
    fillSecondary: {
        color: mainColors.goten,
        backgroundColor: mainColors.hit,
    },
    stroke: {
        color: mainColors.bulma,
        background: 'none',
        boxShadow: `inset 0 0 0 1px ${mainColors.trunks}`,
        '&:hover': {
            boxShadow: `inset 0 0 0 1px ${mainColors.bulma}`,
        },
    },
});
const getButtonTokens = (mainColors) => {
    const tokens = buttonVariantTokens(mainColors);
    return {
        button: {
            primary: tokens.fill,
            secondary: tokens.stroke,
            tertiary: tokens.fillSecondary,
        },
    };
};
export default getButtonTokens;
